const basePath = "https://canva-smarttv.pages.dev/"; //import.meta.env.BASE_URL;
const basePathSamsung = "https://samsung-canva-build.pages.dev/";

export default [
  {
    type: "msdf",
    fontFamily: "Roboto",
    descriptors: {
      weight: 700,
    },
    atlasDataUrl: basePath + "fonts/Roboto-Bold.msdf.json",
    atlasUrl: basePath + "fonts/Roboto-Bold.msdf.png",
  } as const,
  {
    type: "msdf",
    fontFamily: "Roboto",
    descriptors: {
      weight: 400,
    },
    atlasDataUrl: basePath + "fonts/Roboto-Regular.msdf.json",
    atlasUrl: basePath + "fonts/Roboto-Regular.msdf.png",
  } as const,
  {
    type: "msdf",
    fontFamily: "Arial",
    descriptors: {
      weight: 500,
    },
    atlasDataUrl: basePath + "fonts/Roboto-Regular.msdf.json",
    atlasUrl: basePath + "fonts/Roboto-Regular.msdf.png",
  } as const,
  {
    type: "msdf",
    fontFamily: "NotoSansArabic",
    descriptors: { weight: 400 },
    atlasDataUrl: basePathSamsung + "fonts/NotoSansArabic-Regular.msdf.json",
    atlasUrl: basePathSamsung + "fonts/NotoSansArabic-Regular.msdf.png",
  } as const,
  {
    type: "msdf",
    fontFamily: "NotoSansArabic",
    descriptors: { weight: 700 },
    atlasDataUrl: basePathSamsung + "fonts/NotoSansArabic-Bold.msdf.json",
    atlasUrl: basePathSamsung + "fonts/NotoSansArabic-Bold.msdf.png",
  } as const,
];
